<template>
  <v-navigation-drawer app class="custom-navbar" v-model="drawer" width="270" :temporary="props.temporary">
    <v-list density="compact" v-model:opened="open" multiple>
      <v-list-group value="favourite">
          <template #activator>
              <v-list-item @click="toggleFavourite()">
                  <div class="menu-item">
                      <v-icon class="menu-icon">mdi-star</v-icon>
                      <span class="menu-text font-weight-bold">{{$t('favourite')}}</span>
                      <v-icon class="ml-auto">
                          {{ open?.includes("favourite") ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                      </v-icon>
                  </div>
              </v-list-item>
          </template>
          <v-list-group>
            <template #activator>
                <v-list-item v-for="(fav) in favouriteStore.favourite_list" :to="fav.menu_url" link>
                  <div class="menu-item">
                      <span class="menu-text">{{ fav.menu_name }}</span>
                  </div>
                </v-list-item>
            </template>
        </v-list-group>
      </v-list-group>
      <MenuItem v-for="(menu) in menuList" :menu v-model="open" :currentMenuId />
    </v-list>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRoute } from 'vue-router';
import { API_PROPERTY_MANAGER_000 } from "~/constants/property_manager/api-property-manager-000";
import MenuItem from '@/components/property-manager/navbar-menuItem.vue'
import { useFavouriteStore } from '@/stores/favourite';
import { useNotificationStore } from '@/stores/notification';
import type { Prop000001Response, Prop000002Response, MenuItemDto, FavoriteMenu} from "@/types/property-manager/prop-000";
const auth = usePropertyUserStore();
const favouriteStore = useFavouriteStore();
const notificationStore = useNotificationStore();
const props = defineProps<{
    temporary?: boolean,
}>()

const route = useRoute();
const drawer = defineModel<boolean>();
const open: Ref<String[]> = ref([]);

const response1: Ref<Prop000001Response | undefined> = ref();
const response2: Ref<Prop000002Response | undefined> = ref();
const menuList: Ref<MenuItemDto[] | undefined> = ref();
const favouriteList: Ref<FavoriteMenu[] | undefined> = ref();

const match = route.fullPath.match(/prop-(\d+)/i);
const currentMenuId = match ? `PROP${match[1]}`.toUpperCase() : null;
onMounted(async () => {
  menuInit();
});

watch(route, async (to) => {
  localStorage.setItem('click_url', '1');
  if (!auth.isAuthenticated || currentMenuId === 'PROP002') {
    localStorage.setItem('opening_menu', '');
    return;
  } 
  response1.value = (await useApi.post<any>(API_PROPERTY_MANAGER_000.PROP_API_000_001, {}, {})).response_data;
  notificationStore.setter(response1.value?.count_notification ?? 0)
});
watch(open, async (to) => {
  if (localStorage.getItem('click_url') == '1' && open.value.toString() !== localStorage.getItem('opening_menu')) // them cai nay de set lai menu khi thay doi url
  open.value = (localStorage.getItem('opening_menu') || '').split(',').map(item => item.trim());
});

const menuInit = async () => {
  if (!auth.isAuthenticated || currentMenuId === 'PROP002') {
    localStorage.setItem('opening_menu', '');
    return;
  } 
  response1.value = (await useApi.post<any>(API_PROPERTY_MANAGER_000.PROP_API_000_001, {}, {})).response_data;
  menuList.value = response1.value?.menu_list;
  favouriteList.value = response1.value?.favorite_menu_list
  notificationStore.setter(response1.value?.count_notification ?? 0)

  response2.value = (await useApi.post<any>(API_PROPERTY_MANAGER_000.PROP_API_000_002, {menu_id: currentMenuId}, {})).response_data;
  favouriteStore.setter(favouriteList.value)
  await nextTick();
  findOpenMenu(menuList.value);
  open.value = open.value.concat((localStorage.getItem('opening_menu') || '').split(',').map(item => item.trim()));
  open.value = open.value.filter((value, index, self) => value && self.indexOf(value) === index);
  localStorage.setItem('opening_menu', open.value.toString());
}

const findOpenMenu = (menuList: MenuItemDto[] | undefined) => {
  if (menuList) {
    for (let menu of menuList) {
      if (menu.children_menu_list && menu.children_menu_list.find((e: MenuItemDto) => e.menu_id === currentMenuId) ) {
        open.value.push(menu.menu_name);
      }

      if (Array.isArray(menu.children_menu_list)) {
        findOpenMenu(menu.children_menu_list);
      }
    }
  }
}

const toggleFavourite = () => {
  if (open.value) {
    localStorage.setItem('click_url', '0');
    if (open.value.includes('favourite')) {
        open.value = open.value.filter(item => item != "favourite")
        localStorage.setItem('opening_menu', open.value.filter(item => item != "favourite").toString());
    } else {
        open.value?.push("favourite")
        localStorage.setItem('opening_menu', open.value.toString());
    }
  }
}

</script>
<style scoped>
.custom-navbar {
  background-color: #f8f9fa;
}

.menu-item {
  display: flex;
  align-items: center;
}

.menu-icon {
  font-size: 18px;
  margin-right: 8px;
  color: #ff9300;
}

.menu-text {
  font-size: 15px;
}

.custom-sub-item {
  padding-left: 50px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
::v-deep(.v-list-item:hover) {
  background-color: #D2F4EA !important;
}
::v-deep(.v-list-item__append) {
  display: none !important;
}
::v-deep(div.v-list-item--variant-text .v-list-item__overlay) {
  background: none !important;
  border-top: 1px solid black;
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
::v-deep(div.v-list-item--variant-text.v-list-item--active .v-list-item__overlay) {
  border-bottom: 1px solid black;
}
::v-deep(.v-list.v-theme--light .v-list-group:first-child div.v-list-item--variant-text .v-list-item__overlay) {
  border-top: none;
}
::v-deep(.v-list.v-theme--light .v-list-group:last-child div.v-list-item--variant-text .v-list-item__overlay) {
  border-bottom: 1px solid black;
}
::v-deep(a.v-list-item--variant-text.v-list-item--active .v-list-item__overlay) {
  background: #D2F4EA !important;
  opacity: 1;
}
::v-deep(a.v-list-item--variant-text.v-list-item--active .menu-text) {
  font-weight: 700 !important;
  z-index: 999;
}
::v-deep(a.v-list-item--variant-text.v-list-item--active .badge) {
  z-index: 999;
}
@media (max-width: 1500px) {
  ::v-deep(.v-list) {
    margin-bottom: 100px !important;
  }
}
@media (max-width: 500px) {
  ::v-deep(.v-list) {
    margin-bottom: 90px !important;
  }
}
</style>
